import Builder from '../../utils/redux/builder';

const builder = new Builder({
  name: 'elf',
  initialState: {
    isVisible: true,
    isVisibleRoom: false,
    isAnimation: false,
    elfActions: [],
    outsideActions: [],
    isDressed: false,
    activeRoom: null,
    roomStatesStory: [],
  },
  reducers: {
    setIsAnimation: (state, { payload }) => {
      state.isAnimation = payload;
    },
    addAnimations: (state, { payload }) => {
      state.elfActions = payload;
    },
    setIsDressed: (state, { payload }) => {
      state.isDressed = !!payload;
    },
    resetAnimation: (state, { payload }) => {
      if (payload.isAll) {
        state.elfActions = [];
        return;
      }

      state.elfActions = state.elfActions.filter(({ animation }) => animation !== payload.animation);
    },
    addOutsideAnimations: (state, { payload }) => {
      state.outsideActions = payload;
    },
    resetOutsideAnimations: (state, { payload }) => {
      state.outsideActions = state.outsideActions.filter(({ state }) => state !== payload);
    },
    setIsVisible: (state, { payload }) => {
      state.isVisible = payload;
    },
    setIsVisibleRoom: (state, { payload }) => {
      state.isVisibleRoom = payload;
    },
  },
});

builder.addMatcher(
  () => true,
  (state, { payload = {} }) => {
    if (!payload?.profile?.hasOwnProperty?.('eventRoomId')) return;

    state.activeRoom = payload?.profile?.eventRoomId;

    if (state.roomStatesStory.length[state.roomStatesStory.length - 1] !== state.activeRoom)
      state.roomStatesStory.push(state.activeRoom);
  },
);

builder.addExtraReducer({
  'requests/game/collect-quest/fulfilled': (state, { payload }) => {
    state.outsideActions.push({ state: 'main', animation: 'wink' });

    if (payload?.quest?.isDaily) state.outsideActions.push({ state: 'main', animation: 'done' });
  },
  'requests/game/submit-current-quiz-result/fulfilled': (state, { payload }) => {
    const isWin = payload?.result?.isWin;

    if (!isWin) {
      state.outsideActions.push({ state: 'main', animation: 'sad' });
      return;
    }

    state.outsideActions = state.outsideActions.filter(({ animation }) => animation !== 'sad');
    state.outsideActions.push({ state: 'main', animation: 'happy' });
    state.outsideActions.push({ state: 'main', animation: 'done' });
  },
  'requests/game/start/fulfilled': (state, { payload }) => {
    const profile = payload?.profile;

    if (profile && !profile?.attempts) state.outsideActions.push({ state: 'main', animation: 'sad' });
  },
  'requests/game/end/fulfilled': (state, { payload }) => {
    const isWin = payload?.log?.isWin;
    state.outsideActions = state.outsideActions.filter(({ animation }) => animation !== (isWin ? 'sad' : 'done'));
    state.outsideActions.push({ state: 'main', animation: isWin ? 'done' : 'sad' });
  },
});

const elf = builder.create().export();

export const { useElf } = elf.selectors;

export default elf;
